module.exports = __webpack_public_path__ + "img/customer.b550dd6b.png";